import * as ActionType from '../../constants/actionType';

export const resetProtocolExplorerState = () => ({type: ActionType.RESET_PROTOCOL_EXPLORER_STATE});

export const setProtocolClipboardEventType = (eventType) => ({
  type: ActionType.SET_PROTOCOL_CLIPBOARD_EVENT_TYPE,
  data: eventType,
});

export const setProtocolClipboardItems = (items) => ({type: ActionType.SET_PROTOCOL_CLIPBOARD_ITEMS, data: items});

export const resetProtocolClipboard = () => ({type: ActionType.RESET_PROTOCOL_CLIPBOARD});

export const setProtocolStateRunningProtocol = (runningProtocol) => ({
  type: ActionType.SET_PROTOCOL_EXPLORER_RUNNING_PROTOCOL,
  data: runningProtocol,
});

export const setCurrentProtocolFolder = (protocolFolder) => ({
  type: ActionType.SET_CURRENT_PROTOCOL_FOLDER,
  data: protocolFolder,
});

export const setProtocolExplorerExpandedGroups = (expandedGroups) => ({
  type: ActionType.SET_PROTOCOL_EXPLORER_EXPANDED_GROUPS,
  data: expandedGroups,
});

export const setProtocolFolderList = (tree) => ({type: ActionType.SET_PROTOCOL_FOLDER_LIST, data: tree});

export const setSelectedProtocolOrFolder = (protocols) => ({
  type: ActionType.SET_SELECTED_PROTOCOL_OR_FOLDER,
  data: protocols,
});

export const setDefaultViewSettings = (defaultValue) => ({
  type: ActionType.SET_DEFAULT_VIEW_SETTINGS,
  data: defaultValue,
});

export const resetSelectedProtocolOrFolder = () => ({type: ActionType.RESET_SELECTED_PROTOCOL_OR_FOLDER});

export const setProtocolExplorerItems = (items) => ({type: ActionType.SET_PROTOCOL_EXPLORER_ITEMS, items});

export const setProtocolExplorerTrayBoundProtocolIDs = (ids) => ({
  type: ActionType.SET_TRAY_BOUND_PROTOCOL_IDS,
  ids,
});

export const setProtocolExplorerFilter = ({type, value}) => ({
  type: ActionType.SET_PROTOCOL_EXPLORER_FILTER,
  filterObject: {type, value},
});

export const setProtocolExplorerSort = ({direction, accessor}) => ({
  type: ActionType.SET_PROTOCOL_EXPLORER_ACTIVE_SORT,
  sortObject: {direction, accessor},
});
